import { cachebuster } from "./cachebuster";
export function getHTML(url) {
    return fetch(cachebuster(url))
        .then((response) => response.text())
        .then((htmlString) => {
        const html = document.createElement("div");
        html.innerHTML = htmlString;
        return html;
    });
}
